import { IUserModel } from '@/lib/interface.ts';
import { persist } from 'zustand/middleware';
import { ENV } from '@/constants';
import { create } from 'zustand';

const userStore = create<IUserModel>()(
	persist(
		set => ({
			user: null,
			setStoreUser: user => set({ user: user }),
		}),
		{ name: `user-store-${ENV.name.toLowerCase()}` }
	)
);

export default userStore;
